var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasAccount && _vm.isAdmin
    ? _c(
        "div",
        {
          staticClass:
            "app-admin-bar inverted with-border-bottom padding-top-xs",
          staticStyle: {
            "--hr-border-color": "var(--fa-dk-navy)",
            "--hr-border-width": "var(--border-width-md)",
            "--balloon-color": "var(--fa-dk-blue)",
            "--link-color": "var(--fa-gravy)",
            "--link-hover-color": "var(--fa-blue)",
          },
          attrs: { id: "admin-bar" },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row roomy align-middle" }, [
              _c("div", { staticClass: "column" }, [
                _c(
                  "h1",
                  {
                    staticClass: "h5 display-flex flex-items-center margin-0",
                    staticStyle: { gap: "var(--spacing-sm)" },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "muted",
                      attrs: {
                        icon: _vm.$v7.solid.faCog,
                        size: "lg",
                        "fixed-with": "",
                        spin: "",
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(0),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column text-right" }, [
                _c(
                  "ul",
                  {
                    staticClass:
                      "display-flex flex-items-center flex-content-end margin-0",
                    staticStyle: {
                      gap: "var(--spacing-sm)",
                      "--list-margin-top": "0",
                      "--link-decoration-line": "none",
                      "--link-hover-decoration-line": "none",
                      "--list-style-type": "none",
                    },
                  },
                  [
                    _c(
                      "li",
                      { staticClass: "margin-0" },
                      [
                        _c(
                          "site-link",
                          {
                            class: _vm.adminActiveClass("admin.dashboard"),
                            staticStyle: { gap: "var(--spacing-2xs)" },
                            attrs: {
                              to: { name: "admin.dashboard" },
                              "aria-label": "Aye Aye, Admin-ral",
                              "data-balloon-pos": "down",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v7.solid.faClipboard,
                                size: "lg",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "display-none laptop:display-inline",
                              },
                              [_vm._v("Admin")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "margin-0" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "display-inline-flex flex-items-center padding-x-md padding-y-xs",
                          staticStyle: { gap: "var(--spacing-2xs)" },
                          attrs: {
                            href: "/admin/system/dashboard",
                            "aria-label": "Check on the Warp Core",
                            "active-class": "active",
                            "data-balloon-pos": "down",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v7.solid.faGauge, size: "lg" },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "display-none laptop:display-inline",
                            },
                            [_vm._v("System")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "margin-0" },
                      [
                        _c(
                          "site-link",
                          {
                            class: _vm.adminActiveClass("admin.reports"),
                            staticStyle: { gap: "var(--spacing-2xs)" },
                            attrs: {
                              to: { name: "admin.reports" },
                              "aria-label": "Become Lord Business",
                              "data-balloon-pos": "down",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: {
                                icon: _vm.$v7.solid.faChartBar,
                                size: "lg",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "display-none laptop:display-inline",
                              },
                              [_vm._v("Reports")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("li", { staticClass: "margin-0" }, [
                      _c(
                        "a",
                        {
                          staticClass:
                            "display-inline-flex flex-items-center padding-x-md padding-y-xs",
                          staticStyle: { gap: "var(--spacing-2xs)" },
                          attrs: {
                            href: "/admin/oban",
                            "aria-label": "You Will Be A Time Lord",
                            "active-class": "active",
                            "data-balloon-pos": "down",
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v7.solid.faGauge, size: "lg" },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "display-none laptop:display-inline",
                            },
                            [_vm._v("Oban")]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [
      _c("span", { staticClass: "display-none tablet:display-inline" }, [
        _vm._v("Welcome,"),
      ]),
      _vm._v(" Admin"),
      _c("span", { staticClass: "display-none tablet:display-inline" }, [
        _vm._v("istrator of Awesome!"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }